export const handleDeleteFulfilledAction = (state, action) => {
    state.isLoading = false;
    if (Array.isArray(state.data)) { state.data = state.data.filter((item) => item.id !== action.payload); }
};

export const handleFulfilledAction = (state, action) => {
    state.isLoading = false;
    state.data = action.payload;
};

export const handleRejectedAction = (state, action) => {
    state.isLoading = false;
    state.error = action.payload ?? action.error?.message ?? 'Unknown error';
};

export const handlePendingAction = (state) => {
    state.isLoading = true;
};

export const handleRequestThunk = ({ builder, request, isDelete = false }) => {
    const fulfilledActionHandler = isDelete
        ? handleDeleteFulfilledAction
        : handleFulfilledAction;
    return builder
        .addCase(request.pending, handlePendingAction)
        .addCase(request.fulfilled, fulfilledActionHandler)
        .addCase(request.rejected, handleRejectedAction);
};
